import { render, staticRenderFns } from "./SfSkeleton.vue?vue&type=template&id=dab5c5e2&"
import script from "./SfSkeleton.vue?vue&type=script&lang=js&"
export * from "./SfSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./SfSkeleton.vue?vue&type=style&index=0&id=dab5c5e2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports